import { showToast } from "./utils";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import { removeScrollMessage } from "../../../store/operator/actions";

const useTransferConversation = () => {
  const { messageOperator } = useSelector((state) => state.Operator);
  const dispatch = useDispatch();
  const history = useHistory();

  const deleteChat = (chatId) => {
    if (messageOperator?.chats?.data) {
      let aux = messageOperator.chats;
      let pos = -1;

      pos = aux.data.findIndex((e) => e.conversationId === chatId);

      if (pos >= 0) {
        aux.data.splice(pos, 1);
      }
    }
  };

  return {
    handleTransferedByAgent: (
      data,
      activeChat,
      resetActiveChat,
      spyConversation,
      t
    ) => {
      let chatId = data?.conversationId;

      if (chatId) {
        let chat = messageOperator?.chats?.data?.find(
          (e) => e.conversationId === chatId
        );
        let consumer = chat?.consumer?.name;

        if (chatId === activeChat?.conversation?.conversationId) {
          resetActiveChat();
        }
        showToast(
          "info",
          `${t("Chat transfered by agent")} ${
            consumer && "[" + t("Client") + ": " + consumer + "]"
          }`
        );
        // TODO: When back-end permit spy chat on queue the line below was probably deleted
        deleteChat(chatId);
        dispatch(removeScrollMessage(chatId));

        if (spyConversation) {
          // TODO: Temporary redirect to Manager Panel until back-end permit spy chat on queue
          setTimeout(() => history.push("/manager-panel"), 3000);
          // TODO: When back-end permit spy chat on queue the line below was probably in another method: Ex. handleMessageAssinged = (data) => ...
          //dispatch(startObserver(spyConversation));
        }
      }
    },

    handleTransferedByManager: (
      data,
      activeChat,
      resetActiveChat,
      spyConversation,
      t
    ) => {
      let chatId = data?.conversationId;

      if (chatId) {
        let chat = messageOperator?.chats?.data?.find(
          (e) => e.conversationId === chatId
        );
        let consumer = chat?.consumer?.name;

        if (chatId === activeChat?.conversation?.conversationId) {
          resetActiveChat();
        }
        showToast(
          "info",
          `${t("Chat transfered by manager")} ${
            consumer && "[" + t("Client") + ": " + consumer + "]"
          }`
        );
        // TODO: When back-end permit spy chat on queue the line below was probably deleted
        deleteChat(chatId);
        dispatch(removeScrollMessage(chatId));

        if (spyConversation) {
          // TODO: Temporary redirect to Manager Panel until back-end permit spy chat on queue
          setTimeout(() => history.push("/manager-panel"), 3000);
          // TODO: When back-end permit spy chat on queue the line below was probably in another method: Ex. handleMessageAssinged = (data) => ...
          //dispatch(startObserver(spyConversation));
        }
      }
    },

    handleTransferedBySystem: (
      data,
      activeChat,
      resetActiveChat,
      spyConversation,
      t
    ) => {
      let chatId = data?.conversationId;

      if (chatId) {
        let chat = messageOperator?.chats?.data?.find(
          (e) => e.conversationId === chatId
        );
        let consumer = chat?.consumer?.name;

        if (chatId === activeChat?.conversation?.conversationId) {
          resetActiveChat();
        }
        showToast(
          "info",
          `${t("Chat transfered by system")} ${
            consumer && "[" + t("Client") + ": " + consumer + "]"
          }`
        );
        // TODO: When back-end permit spy chat on queue the line below was probably deleted
        deleteChat(chatId);
        dispatch(removeScrollMessage(chatId));

        if (spyConversation) {
          // TODO: Temporary redirect to Manager Panel until back-end permit spy chat on queue
          setTimeout(() => history.push("/manager-panel"), 3000);
          // TODO: When back-end permit spy chat on queue the line below was probably in another method: Ex. handleMessageAssinged = (data) => ...
          //dispatch(startObserver(spyConversation));
        }
      }
    },

    handleTransferChat: (e, spyConversation, resetActiveChat, t) => {
      if (!spyConversation) {
        if (!e?.error && e?.message) {
          showToast("success", t(e?.message));
          resetActiveChat();
          deleteChat(e?.chatId);
          dispatch(removeScrollMessage(e?.chatId));
        } else if (
          e?.error &&
          Array.isArray(e?.message) &&
          e?.message?.length > 0
        ) {
          e.message.map((error) => showToast("error", t(error?.value)));
        } else {
          showToast(
            "error",
            t("Sorry! something went wrong, please contact our support team")
          );
        }
      }
    },
  };
};

export default useTransferConversation;
